module.exports = __webpack_public_path__ + "dist/media/ivan-melo.6848665d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/team/ivan-melo.png
// module id = 385
// module chunks = 0